import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useSite } from "@/lib/site";

export const INSTAGRAM_URL = "https://www.instagram.com/arrow.development.group/";

const en = {
  "nav.courses": "CQB Courses", "nav.gear": "Merch", "nav.workshop": "Workshop", "nav.partners": "Partners", "nav.killhouse": "Killhouse (Soon)", "nav.ethos": "Ethos", "nav.contact": "Contact",
  "nav.shop": "Shop Merch",
  "hero.tag": "A.R.R.O.W Development Group // CQB Sector",
  "hero.lines": ["Close", "Quarters.", "No Margin."],
  "hero.text": "Close quarters battle instruction, team merch, and soon — our own killhouse for live force-on-force training days.",
  "hero.ctaCourses": "View Courses", "hero.ctaKillhouse": "Killhouse (Soon)",
  "hero.pillars": ["CQB Instruction", "Merch", "Killhouse (Soon)"],
  "marquee": ["Force on Force", "Close Quarters Battle", "The Fatal Funnel", "Arrow Apparel", "Train the Threshold", "GBB Only", "A.R.R.O.W Development Group"],
  "courses.eyebrow": "// Instruction", "courses.title": ["CQB", "Courses"],
  "courses.intro": "Small cadre, progressive curriculum. Start at the fundamentals and earn your way into the killhouse.",
  "courses.note": "Select a course to request dates & pricing",
  "courses.gbbTitle": "Airsoft GBB only",
  "courses.gbb": "We train with airsoft replicas — gas blowback (GBB) powered only.",
  "courses.list": [
    ["Fundamentals", "Individual", "Weapon handling in confined space, threshold evaluation, corner fed vs. center fed rooms, single-operator clearing."],
    ["Team Movement", "2–4 Person", "Stack positioning, points of domination, communication under stress, hallway and T-intersection flow."],
    ["Low-Light Ops", "NVG / White Light", "Light discipline, NVG movement, target identification in darkness and transitional lighting."],
    ["Force on Force", "GBB Airsoft", "Scenario-based runs against live role-players. Decisions are tested, not assumed. Debrief after every rep."],
  ],
  "gear.eyebrow": "// Drop 01", "gear.title": ["Team", "Merch."],
  "gear.intro": "Wear the colours. Limited runs — inquire to reserve yours.",
  "gear.inquire": "Inquire Now", "gear.sizes": "Sizes", "gear.note": "Sizes & availability confirmed on inquiry",
  "gear.empty": "New drops incoming. Check back soon.", "gear.photo": "Show photo",
  "price.TBA": "TBA",
  "status.COMING SOON": "COMING SOON", "status.AVAILABLE": "AVAILABLE", "status.PRE-ORDER": "PRE-ORDER", "status.SOLD OUT": "SOLD OUT",
  "inq.kicker": "// Inquiry", "inq.desc": "Leave your details — we reply with availability and pricing.",
  "f.name": "Name", "f.phone": "Phone", "f.email": "Email", "f.message": "Message",
  "inq.placeholder": "Sizes, quantity, questions…", "inq.send": "Send Inquiry", "inq.sending": "Sending…",
  "inq.ok": "Inquiry received. We'll be in touch.",
  "ws.eyebrow": "// Workshop", "ws.title": ["Repairs &", "Upgrades."],
  "ws.intro": "Airsoft replica down, or ready for more? Tell us the brand, model, what you want and your budget — we'll get back to you with a plan.",
  "ws.services": [
    ["Repairs", "Diagnosis and fixes for replicas that aren't performing as they should."],
    ["Upgrades", "Parts and tuning to get more out of your replica."],
  ],
  "ws.formTitle": "Service Request", "ws.imgAlt": "A.R.R.O.W technician working on a GBB replica at the bench", "ws.fig": "FIG. 02 — On the bench", "ws.required": "* Required",
  "ws.types": ["Repair", "Upgrade", "Both"],
  "f.brand": "Brand", "f.model": "Model", "f.details": "What do you want?", "f.budget": "Budget",
  "ws.brandPh": "e.g. Tokyo Marui", "ws.modelPh": "e.g. MWS",
  "ws.detailsPh": "Describe the issue or the upgrade you have in mind…", "ws.budgetPh": "e.g. €150",
  "ws.send": "Send Request", "ws.ok": "Request received. We'll review it and get back to you.",
  "pt.eyebrow": "// Partners", "pt.title": ["Our", "Partners."],
  "pt.intro": "The shops and people we trust and work with.", "pt.shotzone": "Airsoft shop",
  "kh.locked": "Locked", "kh.title": ["The Killhouse", "(Soon)"],
  "kh.text": "Our training facility is in development. Force-on-force training days unlock when the doors open.",
  "kh.teasers": [
    ["Force on Force", "Live role-player opposition with GBB airsoft replicas."],
    ["Team Runs", "2–4 person stacks through a purpose-built structure."],
    ["Low-Light", "Night scenarios under NVG and white light."],
  ],
  "ethos.eyebrow": "// Ethos",
  "ethos.lines": ["We teach the room.", "The door, the corner,", "the funnel — until it's", "automatic."],
  "ethos.text": "A.R.R.O.W Development Group exists to build competent, confident operators in close quarters. We run small classes, demand discipline, and debrief every rep.",
  "ethos.principles": [
    ["Accountability", "Every rep is debriefed. Every mistake becomes the next drill."],
    ["Repetition", "Fundamentals until they are automatic, then pressure until they hold."],
    ["Realism", "Live opposition, honest feedback, environments that push back."],
  ],
  "contact.eyebrow": "// Comms", "contact.title": ["Make", "Contact."],
  "contact.intro": "Private classes, group bookings, bulk merch, or killhouse questions — send it.",
  "contact.types": ["CQB Course", "Merch", "Killhouse", "Other"],
  "contact.send": "Transmit", "contact.sending": "Transmitting…", "contact.ok": "Message received. Stand by.",
  "footer.tagline": "CQB instruction, team merch, and soon — force-on-force training days.",
  "footer.staff": "Staff Login", "instagram": "Follow on Instagram",
  "nav.gallery": "Gallery", "gallery.eyebrow": "// Gallery", "gallery.title": ["In The", "Field."],
};

const pt = {
  "nav.courses": "Cursos CQB", "nav.gear": "Merch", "nav.workshop": "Oficina", "nav.partners": "Parceiros", "nav.killhouse": "Killhouse (Em breve)", "nav.ethos": "Ethos", "nav.contact": "Contacto",
  "nav.shop": "Ver Merch",
  "hero.tag": "A.R.R.O.W Development Group // Setor CQB",
  "hero.lines": ["Combate", "Interior.", "Sem Margem."],
  "hero.text": "Instrução de combate em espaços confinados (CQB), merch da equipa e, em breve, a nossa própria killhouse para dias de treino force-on-force.",
  "hero.ctaCourses": "Ver Cursos", "hero.ctaKillhouse": "Killhouse (Em breve)",
  "hero.pillars": ["Instrução CQB", "Merch", "Killhouse (Em breve)"],
  "marquee": ["Force on Force", "Combate em Espaços Confinados", "O Funil Fatal", "Arrow Apparel", "Domina a Entrada", "Apenas GBB", "A.R.R.O.W Development Group"],
  "courses.eyebrow": "// Instrução", "courses.title": ["Cursos", "CQB"],
  "courses.intro": "Equipa de instrutores reduzida, currículo progressivo. Começa pelos fundamentos e conquista o teu lugar na killhouse.",
  "courses.note": "Seleciona um curso para pedir datas e preços",
  "courses.gbbTitle": "Apenas Airsoft GBB",
  "courses.gbb": "Treinamos com réplicas de airsoft — exclusivamente a gás com blowback (GBB).",
  "courses.list": [
    ["Fundamentos", "Individual", "Manuseamento da arma em espaços confinados, avaliação da entrada, divisões com entrada pelo canto vs. pelo centro, limpeza individual."],
    ["Movimento em Equipa", "2–4 Pessoas", "Posicionamento em fila (stack), pontos de domínio, comunicação sob stress, progressão em corredores e cruzamentos em T."],
    ["Pouca Luz", "NVG / Luz Branca", "Disciplina de luz, movimento com NVG, identificação de alvos na escuridão e em iluminação de transição."],
    ["Force on Force", "Airsoft GBB", "Cenários contra role-players reais. As decisões são testadas, não assumidas. Debriefing após cada repetição."],
  ],
  "gear.eyebrow": "// Drop 01", "gear.title": ["Merch da", "Equipa."],
  "gear.intro": "Veste as cores. Edições limitadas — envia um pedido para reservar o teu.",
  "gear.inquire": "Pedir Informação", "gear.sizes": "Tamanhos", "gear.note": "Tamanhos e disponibilidade confirmados no pedido",
  "gear.empty": "Novos drops a caminho. Volta em breve.", "gear.photo": "Ver foto",
  "price.TBA": "A anunciar",
  "status.COMING SOON": "EM BREVE", "status.AVAILABLE": "DISPONÍVEL", "status.PRE-ORDER": "PRÉ-ENCOMENDA", "status.SOLD OUT": "ESGOTADO",
  "inq.kicker": "// Pedido de informação", "inq.desc": "Deixa os teus dados — respondemos com disponibilidade e preços.",
  "f.name": "Nome", "f.phone": "Telemóvel", "f.email": "Email", "f.message": "Mensagem",
  "inq.placeholder": "Tamanhos, quantidade, dúvidas…", "inq.send": "Enviar Pedido", "inq.sending": "A enviar…",
  "inq.ok": "Pedido recebido. Entraremos em contacto.",
  "ws.eyebrow": "// Oficina", "ws.title": ["Reparações &", "Upgrades."],
  "ws.intro": "A tua réplica de airsoft avariou ou queres levá-la mais longe? Indica a marca, o modelo, o que pretendes e o teu orçamento — respondemos com um plano.",
  "ws.services": [
    ["Reparações", "Diagnóstico e reparação de réplicas que não estão a funcionar como deviam."],
    ["Upgrades", "Peças e afinação para tirares mais partido da tua réplica."],
  ],
  "ws.formTitle": "Pedido de Serviço", "ws.imgAlt": "Técnico da A.R.R.O.W a trabalhar numa réplica GBB na bancada", "ws.fig": "FIG. 02 — Na bancada", "ws.required": "* Obrigatório",
  "ws.types": ["Reparação", "Upgrade", "Ambos"],
  "f.brand": "Marca", "f.model": "Modelo", "f.details": "O que pretendes?", "f.budget": "Orçamento",
  "ws.brandPh": "ex.: Tokyo Marui", "ws.modelPh": "ex.: MWS",
  "ws.detailsPh": "Descreve o problema ou o upgrade que tens em mente…", "ws.budgetPh": "ex.: 150 €",
  "ws.send": "Enviar Pedido", "ws.ok": "Pedido recebido. Vamos analisá-lo e entrar em contacto.",
  "pt.eyebrow": "// Parceiros", "pt.title": ["Os Nossos", "Parceiros."],
  "pt.intro": "As lojas e pessoas em quem confiamos e com quem trabalhamos.", "pt.shotzone": "Loja de airsoft",
  "kh.locked": "Bloqueado", "kh.title": ["A Killhouse", "(Em breve)"],
  "kh.text": "As nossas instalações de treino estão em desenvolvimento. Os dias de treino force-on-force serão desbloqueados quando abrirmos portas.",
  "kh.teasers": [
    ["Force on Force", "Oposição real com role-players e réplicas de airsoft GBB."],
    ["Treino em Equipa", "Filas de 2–4 pessoas numa estrutura construída de raiz."],
    ["Pouca Luz", "Cenários noturnos com NVG e luz branca."],
  ],
  "ethos.eyebrow": "// Ethos",
  "ethos.lines": ["Ensinamos a divisão.", "A porta, o canto,", "o funil — até se", "tornar automático."],
  "ethos.text": "O grupo A.R.R.O.W Development Group existe para formar operadores competentes e confiantes em espaços confinados. Turmas pequenas, disciplina exigente e debriefing em cada repetição.",
  "ethos.principles": [
    ["Responsabilidade", "Cada repetição é analisada. Cada erro torna-se o próximo exercício."],
    ["Repetição", "Fundamentos até serem automáticos, depois pressão até se manterem."],
    ["Realismo", "Oposição real, feedback honesto, ambientes que respondem."],
  ],
  "contact.eyebrow": "// Comunicações", "contact.title": ["Entra em", "Contacto."],
  "contact.intro": "Aulas privadas, reservas de grupo, merch em quantidade ou dúvidas sobre a killhouse — envia.",
  "contact.types": ["Curso CQB", "Merch", "Killhouse", "Outro"],
  "contact.send": "Transmitir", "contact.sending": "A transmitir…", "contact.ok": "Mensagem recebida. Aguarda.",
  "footer.tagline": "Instrução CQB, merch da equipa e, em breve, dias de treino force-on-force.",
  "footer.staff": "Acesso Staff", "instagram": "Seguir no Instagram",
  "nav.gallery": "Galeria", "gallery.eyebrow": "// Galeria", "gallery.title": ["No", "Terreno."],
};

export const DICT = { en, pt };
const LangContext = createContext(null);

export const flattenDict = (d) => {
  const out = [];
  const walk = (v, path) => {
    if (Array.isArray(v)) v.forEach((x, i) => walk(x, `${path}|${i}`));
    else if (typeof v === "string") out.push([path, v]);
  };
  Object.entries(d).forEach(([k, v]) => walk(v, k));
  return out;
};

const withOverrides = (base, ov = {}) => {
  const d = structuredClone(base);
  Object.entries(ov).forEach(([path, val]) => {
    if (!val) return;
    const [key, ...idx] = path.split("|");
    if (!(key in d)) return;
    if (!idx.length) { d[key] = val; return; }
    let node = d[key];
    for (let i = 0; i < idx.length - 1; i += 1) node = node?.[idx[i]];
    if (Array.isArray(node)) node[idx[idx.length - 1]] = val;
  });
  return d;
};

export const LangProvider = ({ children }) => {
  const { config } = useSite();
  const [lang, setLang] = useState(() => (localStorage.getItem("arrow-lang") === "pt" ? "pt" : "en"));
  useEffect(() => {
    localStorage.setItem("arrow-lang", lang);
    document.documentElement.lang = lang === "pt" ? "pt-PT" : "en";
  }, [lang]);
  const dict = useMemo(() => withOverrides(DICT[lang], config.texts?.[lang]), [lang, config.texts]);
  const t = (k) => dict[k] ?? en[k] ?? k;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
